import React from 'react';
import { useWidgetPlugin } from './useWidgetPlugin';
import classes from '../slotsPlaceholder.scss';
import { useSlotHighlighting } from './useSlotHighlighting';
import { useSlotUniqueId } from './useSlotUniqueId';
export const useSlotPlaceholder = (slotId) => {
    const { PluginComponent, isEmpty } = useWidgetPlugin(slotId);
    const isHighlighted = useSlotHighlighting(slotId);
    const slotUniqueId = useSlotUniqueId(slotId);
    const Placeholder = () => (React.createElement("div", { id: slotUniqueId, "data-hook": `slot-placeholder-${slotUniqueId}`, className: isHighlighted ? classes.slotHighlighted : '' }, !isEmpty && React.createElement(PluginComponent, null)));
    return [Placeholder, isEmpty];
};
//# sourceMappingURL=useSlotPlaceholder.js.map